var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedTempIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.598 9.8a.6.6 0 10-1.2 0l.002 3.915a1.6 1.6 0 101.2 0L12.598 9.8z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 8.4v-.002a2.799 2.799 0 015.596 0v4.534a3.6 3.6 0 11-5.593 0c0-1.39-.006-3.184-.006-4.533H9.2zm1.2-.002c-.004 1.664.003 3.33.003 4.994l-.16.173a2.4 2.4 0 103.514 0l-.16-.173V8.398a1.599 1.599 0 00-3.197 0z",
    fill: "#fff"
  })));
}

export default SvgLedTempIcon;